import { USER_ROLE_CUSTOMER } from '@blocks/constants';
import { clearStorage } from '@blocks/stores/order';
import {
  and,
  apipe,
  debug,
  handleErrors,
  is,
  isNot,
  sideEffect,
  when,
  whenSideEffect,
} from '@blocks/utils';

import {
  genRecaptchaToken,
  getSession,
  getUserCheck,
  navigate,
  postCustomer,
  postDataBox,
  postSession,
} from '../api';

import { initialValues } from '.';

const onSubmit =
  (config = {}) =>
  values => {
    const {
      recaptcha_site_key,
      utc_offset_min,
      domain,
      onSignIn,
      onSignUp,
      onNewOrder,
      openAuthModal,
      setLoading,
    } = config;

    return apipe(
      debug(
        sideEffect(() => setLoading(true)),
        'order: loading on',
      ),
      when(is('login'), debug(getUserCheck, 'order: getUserCheck')),
      when(is('register_ability', 'policy_agree'), debug(postCustomer, 'order: postCustomer')),
      when(
        is('login_ability', 'user_role_matched', 'password'),
        debug(genRecaptchaToken, 'order: genRecaptchaToken Login'),
      ),
      when(is('captcha_token'), debug(postSession, 'order: postSession')),
      when(
        and(is('login_ability'), isNot('errors.password_incorrect')),
        debug(getSession, 'order: getSession'),
      ),
      when(and(is('login_ability'), isNot('user_id')), debug(openAuthModal, 'order: loginIfAble')),
      when(
        is('user_id'),
        debug(whenSideEffect(is('is_new_customer'), onSignUp), 'order: ga4 onSignUp'),
      ),
      when(
        and(is('user_id'), is('password')),
        debug(whenSideEffect(isNot('is_new_customer'), onSignIn), 'order: ga4 onSignIn'),
      ),
      when(is('user_id'), debug(postDataBox, 'order: postDataBox')),
      when(is('data_box_key', 'user_id'), debug(sideEffect(onNewOrder), 'orderL ga4 onNewOrder')),
      when(is('data_box_key', 'user_id'), debug(navigate, 'order: navigate')),
      when(is('data_box_key', 'user_id'), debug(clearStorage, 'order: clearStorage')),
      when(
        isNot('user_id'),
        debug(
          sideEffect(() => setLoading(false)),
          'order: loading off',
        ),
      ),
      debug(handleErrors, 'order: handleErrors'),
    )({
      ...initialValues,
      ...values,
      recaptcha_site_key,
      utc_offset_min,
      domain,
      recaptcha_action: 'POST/users/sessions',
      route: 'new_order',
      user_role: USER_ROLE_CUSTOMER,
    });
  };

export default onSubmit;
